export default "__VITE_ASSET__DCcHr4vW__"